/**
 * InfinitSales - Eventos de sistema da thread
 *
 * Busca os eventos de transferência do contato (`contact_assignment_events`,
 * via GET /api/contacts/{phone}/assignment/history) e devolve no formato que o
 * ChatWindow intercala com as mensagens: `{ __threadEvent, ts, event }`, onde
 * `ts` é o MESMO relógio das mensagens (unix em segundos), para a ordenação
 * cronológica sair correta com uma comparação só.
 *
 * `refreshKey` força a releitura quando o responsável muda ao vivo (o SSE de
 * atribuição atualiza o assigned_to, e o card novo precisa aparecer sem F5).
 *
 * Best-effort: falha de rede devolve lista vazia — a thread continua
 * renderizando as mensagens normalmente, sem card.
 */
import { useEffect, useState } from 'react';
import assignmentService from '../services/global/assignmentService';

const toUnixSeconds = (timestamp) => {
  if (!timestamp) return null;
  const ms = new Date(timestamp).getTime();
  return Number.isNaN(ms) ? null : Math.floor(ms / 1000);
};

const useThreadEvents = (phone, refreshKey = null) => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    let cancelled = false;

    if (!phone) {
      setEvents([]);
      return undefined;
    }

    (async () => {
      try {
        const res = await assignmentService.getHistory(phone, 50);
        const raw = res?.data?.events || [];
        const mapped = raw
          .map((event) => ({
            __threadEvent: true,
            id: `evt-${event.id}`,
            ts: toUnixSeconds(event.timestamp),
            event,
          }))
          .filter((item) => item.ts !== null);
        if (!cancelled) setEvents(mapped);
      } catch (err) {
        if (!cancelled) setEvents([]);
      }
    })();

    return () => { cancelled = true; };
  }, [phone, refreshKey]);

  return events;
};

export default useThreadEvents;
